<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LGZoip/images/cover.jpg?1702297693414" alt="This image is the cover for the book Morocco"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Morocco
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The acclaimed food writer and photographer explores the rich and varied cuisine of Morocco in this sumptuously illustrated cookbook.</b></p><p> With a wide range of exotic flavors and cooking styles, <i>Morocco</i> includes eighty recipes with Spanish influences, rustic Berber styles, complex, palace-worthy plates, spicy tagines, and surprisingly easy to make street food. Here you will discover piquant appetizers like cumin-spiced potato fritters, classic tagine and couscous entrees, stuffed pastries like Seafood Pastilla, fragrant sweets like Honeyed Phyllo Triangles Stuffed with Almonds, and, of course, Mint Tea. </p> Drawing on culinary traditions from across Morocco’s diverse geography—from the Atlantic and Mediterranean coasts to the Sahara Desert—this beautiful collection of recipes surprises and inspires the home cook. Gorgeous photographs of such iconic Moroccan scenes as the markets of Marrakech and the date-filled oasis of Zagora capture the many flavors of this sun-splashed country. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeff Koehler
      </h2>
      
      <p class="authorDescription body article">Jeff Koehler is a culinary journalist and the author of <I>La Paella</I> and <I>Rice, Pasta, Couscous</I>. His writing and photographs, primarily about the foods of the Mediterranean, have appeared in <I>Saveur</I>, <I>Food &amp; Wine</I>, <I>EatingWell</I>, and the <I>Washington Post</I>. He lives with his family in Barcelona.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f9edb1c8